import { lodash } from '@tarslib/collection/lib/util';
import { Property } from '@tarslib/collection';
import VariableScope from './VariableScope.js';
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var BUILT_IN_ENV_KEYS = ['BASE_URL', 'BASE_URLS'];
var Environment = /*#__PURE__*/function (_Property) {
  function Environment(definition) {
    var _definition$baseUrls, _definition$websocket, _ref, _definition$baseUrl, _definition$baseUrls2, _definition$parameter, _definition$parameter2, _definition$parameter3, _definition$parameter4;
    var _this;
    _classCallCheck(this, Environment);
    // @ts-ignore
    _this = _callSuper(this, Environment, [definition]);
    _defineProperty(_this, "type", 'normal');
    _this.baseUrls = (_definition$baseUrls = definition.baseUrls) !== null && _definition$baseUrls !== void 0 ? _definition$baseUrls : {};
    _this.websocketBaseUrls = (_definition$websocket = definition.websocketBaseUrls) !== null && _definition$websocket !== void 0 ? _definition$websocket : {};
    _this.baseUrl = (_ref = (_definition$baseUrl = definition.baseUrl) !== null && _definition$baseUrl !== void 0 ? _definition$baseUrl : definition === null || definition === void 0 || (_definition$baseUrls2 = definition.baseUrls) === null || _definition$baseUrls2 === void 0 ? void 0 : _definition$baseUrls2["default"]) !== null && _ref !== void 0 ? _ref : '';
    _this.variable = new VariableScope({
      // @ts-ignore
      values: definition.variable.values,
      name: definition.name,
      baseUrls: _this.baseUrls,
      baseUrl: _this.baseUrl
    });
    _this.parameter = {
      header: ((_definition$parameter = definition.parameter) === null || _definition$parameter === void 0 ? void 0 : _definition$parameter.header) || [],
      query: ((_definition$parameter2 = definition.parameter) === null || _definition$parameter2 === void 0 ? void 0 : _definition$parameter2.query) || [],
      body: ((_definition$parameter3 = definition.parameter) === null || _definition$parameter3 === void 0 ? void 0 : _definition$parameter3.body) || [],
      cookie: ((_definition$parameter4 = definition.parameter) === null || _definition$parameter4 === void 0 ? void 0 : _definition$parameter4.cookie) || []
    };
    _this.type = definition.type;
    _this.requestProxyAgentSettings = definition.requestProxyAgentSettings;
    return _this;
  }
  _inherits(Environment, _Property);
  return _createClass(Environment, [{
    key: "getFullVariableScope",
    value: function getFullVariableScope() {
      var _this$getExtraVariabl;
      var _this$variable$toJSON = this.variable.toJSON(),
        values = _this$variable$toJSON.values;
      (_this$getExtraVariabl = this.getExtraVariables()) === null || _this$getExtraVariabl === void 0 || _this$getExtraVariabl.forEach(function (variable) {
        if (!values.find(function (item) {
          return item.key === variable.key;
        })) {
          values.push(variable);
        }
      });
      return new VariableScope({
        values: values,
        name: this.name,
        baseUrls: this.baseUrls,
        baseUrl: this.baseUrl
      });
    }
  }, {
    key: "getExtraVariables",
    value: function getExtraVariables() {
      var _this$baseUrls;
      if (((_this$baseUrls = this.baseUrls) === null || _this$baseUrls === void 0 ? void 0 : _this$baseUrls["default"]) !== undefined) {
        return [{
          key: BUILT_IN_ENV_KEYS[0],
          value: this.baseUrls["default"],
          builtIn: true
        }, {
          type: 'object',
          key: BUILT_IN_ENV_KEYS[1],
          value: this.baseUrls,
          builtIn: true
        }];
      }
      return [];
    }
  }], [{
    key: "isEnvironment",
    value: function isEnvironment(obj) {
      return Boolean(obj) && (obj instanceof Environment || lodash.inSuperChain(obj.constructor, '_postman_propertyName', Environment._postman_propertyName));
    }
  }]);
}(Property);
_defineProperty(Environment, "_postman_propertyName", 'Environment');
export { BUILT_IN_ENV_KEYS, Environment as default };
